import React from 'react';
import { useSelectActiveInput } from 'portfolio/store/selectors';
import { usePortfolioSelectedSymbol } from 'portfolio/store/hooks';

import { Button } from '@instinet-analytics/semantic-ui-components';
import { useDispatchPositionEntryClear } from './store/dispatchers';
import OverlayPanel from 'utils/components/OverlayPanel/OverlayPanel';

export default function PositionEntryWidgetInputOverlay() {
    const activeInput = useSelectActiveInput();
    const symbol = usePortfolioSelectedSymbol();
    const dispatchPositionEntryClear = useDispatchPositionEntryClear();

    if (activeInput.activeInputType !== 'Position Entry') {
        return null;
    }

    const onClickClear = () => dispatchPositionEntryClear(true);

    return (
        <OverlayPanel className="PositionEntryWidgetInputOverlay ">
            <div className="content">
                <div className="title">
                    Currently viewing &quot;{symbol}&quot;
                </div>
                <div className="subtitle">
                    The menu search is overriding the Widget. Clear the search
                    to resume using the Input Widget.
                </div>
                <Button primary onClick={onClickClear}>
                    Clear Search
                </Button>
            </div>
        </OverlayPanel>
    );
}
